import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from './token/token.service';

@Injectable({
  providedIn: 'root'
})
export class CardsService {
  
  private iconData = [
    { name: 'Aquário', icon: '/assets/svg/aquario.svg', count: 2 },
    { name: 'Bonde', icon: '/assets/svg/bonde.svg', count: 5 },
    { name: 'Praias', icon: '/assets/svg/praia.svg', count: 3 },
    { name: 'Crianças', icon: '/assets/svg/crianca.svg', count: 4 },
    { name: 'Parques', icon: '/assets/svg/parque.svg', count: 6 },
    { name: 'Praças', icon: '/assets/svg/praca.svg', count: 7 },
    { name: 'Jardins', icon: '/assets/svg/jardim.svg', count: 8 },
    { name: 'Teatros', icon: '/assets/svg/teatro.svg', count: 9 },
    { name: 'Balsas', icon: '/assets/svg/balsa.svg', count: 10 },
    { name: 'Eventos', icon: '/assets/svg/evento.svg', count: 11 },
    { name: 'Feiras', icon: '/assets/svg/feira.svg', count: 12 },
    { name: 'Cinemas', icon: '/assets/svg/cinema.svg', count: 13 },
    { name: 'Bicicletas', icon: '/assets/svg/bicicleta.svg', count: 2 },
    { name: 'Animais', icon: '/assets/svg/animal.svg', count: 5 },
    { name: 'Emergência', icon: '/assets/svg/emergencia.svg', count: 3 },
    { name: 'Catedral', icon: '/assets/svg/catedral.svg', count: 4 },
    { name: 'Museus', icon: '/assets/svg/museu.svg', count: 6 },
    { name: 'Bibliotecas', icon: '/assets/svg/biblioteca.svg', count: 7 },
    { name: 'Delegacias', icon: '/assets/svg/delegacia.svg', count: 8 },
    { name: 'Memoriais', icon: '/assets/svg/memorial.svg', count: 9 },
    { name: 'Esportes', icon: '/assets/svg/esporte.svg', count: 10 },
    { name: 'Mercado', icon: '/assets/svg/mercado.svg', count: 11 },
    { name: 'Consulados', icon: '/assets/svg/consulado.svg', count: 12 },
    { name: 'Cemitérios', icon: '/assets/svg/cemiterio.svg', count: 13 }
  ];
  
  token: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDT0RJR09fVVNVQVJJTyI6IjEwODgiLCJBUFBfSUQgKElOSUNJQUwpIjoiODZiZjlmYzYtNzhhZC00YTY1LTg5ZTgtOGM5MWY4ZWFjNDNkIiwiTE9HSU4iOiJBZG1pbmlzdHJhQUNUTyIsIklQQUREUkVTUyI6Ijo6MSIsIlVJUF9JRCI6ImI0ODlmNGYzLThkMmUtNDhjZS1iNzVhLTBkYzYxY2RiMTU4MiIsIkNDVE9LRU4iOiIiLCJBUFBfSUQiOiI4NmJmOWZjNi03OGFkLTRhNjUtODllOC04YzkxZjhlYWM0M2QiLCJQQVJBTV9MT0dJTiI6Ilt7XCJpZFwiOjUzNzIsXCJ0aXBvXCI6XCJDb2RDbGllbnRlXCIsXCJjaGF2ZVwiOlwiTW9kZWxvIC0gQ2lkYWRlIEludGVsaWdlbnRlXCIsXCJ2YWxvclwiOlwiMjIxXCJ9XSIsIkZVTkNBTyI6WyJfMTEtNiIsIl8xLTUiLCJfMTAtNSIsIl8xMS01IiwiXzEyLTUiLCJfMTQtNSIsIl8yLTUiLCJfMy01IiwiXzQtNSIsIl81LTUiLCJfNi01IiwiXzctNSIsIl84LTUiLCJfOS01IiwiMTAtMTUiLCIxMDAtMSIsIjEwMS0xNSIsIjExLTE1IiwiMTEzLTE1IiwiMTE5LTEiLCIxMi0xNSIsIjEyMC0xNSIsIjEyMS0xIiwiMTMtMTUiLCIxMzEtMTUiLCIxMzMtMTUiLCIxNC0xNSIsIjE2LTE1IiwiMTgtMSIsIjE5LTEiLCIyMC0xIiwiMjEtMSIsIjIyLTEiLCIyMy0xNSIsIjI2LTEiLCIyNy0xIiwiMjktMSIsIjQzLTEiLCI0NC0xIiwiNDctMSIsIjQ4LTEiLCI0OS0xIiwiNS0xNSIsIjUwLTEiLCI1My0xIiwiNTQtMSIsIjU1LTEiLCI1Ny0xIiwiNTgtMSIsIjYtMTUiLCI2MC0xNSIsIjY0LTE1IiwiNjYtMSIsIjY3LTEiLCI2OS0xMyIsIjctMTUiLCI3MC0xNSIsIjcxLTEiLCI3Ni0xIiwiNzktMSIsIjgtMTUiLCI4MS0xIiwiODItMSIsIjgzLTEiLCI4NC0xIiwiODUtMSIsIjg3LTE1IiwiOS0xNSIsIjkwLTE1IiwiOTEtMSJdLCJuYmYiOjE3MjgwNzE5NzUsImV4cCI6MTg4NTc1MjAzNSwiaWF0IjoxNzI4MDcyMDM1LCJpc3MiOiJodHRwOi8vd3d3LmNvZGVjaXBoZXJzLmNvbSIsImF1ZCI6Imh0dHA6Ly93d3cuY29kZWNpcGhlcnMuY29tIn0.-wT0AHmdPAZMuUW-capxumf52hzEtKtnVBDBnZzB_jM'

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  getIcons(): Observable<any[]> {
    return of(this.iconData);
  }
  
  getInfoCards(codEntidadeNegocio: number, codCatalogo: number): Observable<any> {
    const body = {
      codEntidadeNegocio,
      codCatalogo
    };
    
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.tokenService.getToken()!}`
    });

    return this.http.post<any>
      ('https://oshomolog.acto.net.br/api/EntidadeNegocio/ObterEntidadeNegocioMetadado', body, { headers });
  }
  
  getCards(): Observable<any> {
    const body = {
      codEntidadeNegocio: 19045, 
      codCatalogo: 13215 
    };

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.tokenService.getToken()!}`
    });

    return this.http.post<any>(
      'https://oshomolog.acto.net.br/api/EntidadeNegocio/ObterEntidadeNegocioMetadado',
      body,
      { headers }
    );
  }

}
